import React from 'react';

import { LegacyBox, Help, styled } from '@gogame/components';

const tooltipCBudget = 'Sum of budgets, that were allocated on lower levels';

export const LabelCBudget = () => (
  <LegacyBox align={'center'} justifyContent={'flex-end'} gutter={4}>
    <LegacyBox>cBudget</LegacyBox>
    <Help>{tooltipCBudget}</Help>
  </LegacyBox>
);

export const LabelInline = styled('span')`
  white-space: nowrap;
`;
